const o=o=>o.length>0?o[0]:void 0;export{o as first};
//# sourceMappingURL=first.js.map
